import React from "react";
import AppConfig, { AppConfigEnvironment } from "../entities/AppConfig";
import { GoogleProdApiDefaults } from "../config";

export const defaultAppConfig: AppConfig = {
    environment: AppConfigEnvironment.Production,
    googleAnalytics: {
        isEnabled: false,
        trackingId: "",
    },
    mikesGoogleAnalytics: {
        isEnabled: false,
        trackingId: "",
    },
    mainSiteUrl: "https://www.sermoncentral.com",
    makerSiteUrl: "https://maker.sermoncentral.com",
    accountSiteUrl: "https://account.sermoncentral.com",
    paymentsSiteUrl: "https://payments.sermoncentral.com",
    stripeApiKey: "pk_test_0AMNW7y4XfzPoofBDiYEUxNt",
    assetBaseUrl: "https://i.cdn-sc.com",
    googleSlidesApi: GoogleProdApiDefaults.googleSlidesApi,
}

type SetAppConfig = (config: AppConfig) => void;

export const AppConfigContext = React.createContext<[AppConfig, SetAppConfig]>([defaultAppConfig, () => {}]);

export function useAppConfig() {
	return React.useContext(AppConfigContext);
}